import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ScoreLogo } from '../components/Logo';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = location.hash || window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/auth');
          return;
        }

        const user = await loginWithGoogle(sessionId);
        window.history.replaceState(null, '', window.location.pathname);

        if (user.profile_complete) {
          navigate('/discover', { state: { user }, replace: true });
        } else {
          navigate('/profile-setup', { state: { user }, replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/auth');
      }
    };

    processAuth();
  }, [location.hash, loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="flex flex-col items-center gap-6">
        <div className="animate-pulse">
          <ScoreLogo size={72} />
        </div>
        <p className="font-body text-gray-500">Signing you in...</p>
      </div>
    </div>
  );
};
